import _ from 'lodash';
import { Service } from './Service';
import { log, now, ndjson } from '~/utils';
import Promise from 'bluebird';

export class FriendsService extends Service {

  get name() { return 'friends'; }
  get extension() { return '.ndjson'; }

  /*
  async get( membershipId, params ) {
    return ndjson.reader( this.pathto( membershipId ) );
  }
  */

  async resolve( friendId ) {
    return this.app.service( 'members' ).get( friendId );
  }

  async create( data, params ) {
    const { membershipId, memberId, friendId } = data;
    if ( ! membershipId ) {
      this.throw( 'BadRequest', `Friends.create requires membershipId` );
    }
    if ( ! memberId ) {
      this.throw( 'BadRequest', `Friends.create requires memberId` );
    }
    if ( ! friendId ) {
      this.throw( 'BadRequest', `Friends.create requires friendId` );
    }
    const friend = {
      ts : now(),
      memberId,
      friendId,
    };
    await ndjson.append( this.pathto( membershipId ), friend );
    return this.resolve( friend.friendId );
  }

  async find( { query, ...params } ) {
    log.debug( 'FriendsService#find', query, params );
    const keys = _.keys( query );
    const key = keys.sort().join( '-' );
    const members = this.app.service( 'members' );
    if ( key === 'membershipId' ) {
      // This is a shortcut for finding all the friends for a given
      // membershipId without having to query them all.
      const ids = await this.getFriendIdsForMembership( query.membershipId );
      return Promise.map( ids, id => members.get( id ) );
    } else if ( key === 'membershipId-name' ) {
      // Searching for someone by name
      const re = new RegExp( query.name, 'iu' );
      // TODO - Config
      const nameFields = [ 'name', 'firstName', 'lastName', 'displayName' ];
      const matcher = rec => {
        // TODO - Config + capabilities
        if ( ! ( rec.type === 'junior' || rec.type === 'child' ) ) {
          return false;
        }
        for ( const f of nameFields ) {
          if ( ! _.isString( rec[ f ] ) ) continue;
          if ( re.test( rec[ f ].toLowerCase() ) ) return true;
        }
        return false;
      };
      return members.filter( matcher );
    }
    this.throw( 'BadRequest', 'Invalid friends query' );
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
